module.exports = __webpack_public_path__ + "static/09-2ea73fc6702fda3a8ddfa5f63d5403c1.jpg";